"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_3 = require("@l2p/ui-components");
var apps_shared_2 = require("@l2p/apps-shared");
var NewGames = function (_a) {
    var closeDigest = _a.closeDigest, gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, swr_hooks_1.useGamesByCategories)(), data = _b.data, isLoading = _b.isLoading;
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var games = (0, react_1.useMemo)(function () {
        var _a;
        return ((_a = data === null || data === void 0 ? void 0 : data[apps_shared_1.Categories.RECOMMENDED]) === null || _a === void 0 ? void 0 : _a.previewGames) || [];
    }, [data]);
    var slicedGames = (0, react_1.useMemo)(function () { return (breakpoints.mobile ? games.slice(0, 5) : games.slice(0, 7)); }, [breakpoints.mobile, games]);
    var moreGamesClick = (0, react_1.useCallback)(function () {
        closeDigest();
        router.push(generateUrlWithLang("/games/".concat(apps_shared_1.Categories.RECOMMENDED)));
    }, [closeDigest, generateUrlWithLang, router]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('recommendedGames')),
        isLoading ? (react_1.default.createElement(ui_components_3.LoadingWithContainer, null)) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, slicedGames === null || slicedGames === void 0 ? void 0 :
            slicedGames.map(function (game, idx) {
                var _a;
                return (react_1.default.createElement("div", { key: "game_digest_newGames_".concat(idx) }, breakpoints.mobile || breakpoints.tablet ? (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "".concat(game.id).concat(idx), title: game.title, gameId: game === null || game === void 0 ? void 0 : game.id, slug: game === null || game === void 0 ? void 0 : game.slug, clickEvent: closeDigest, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_2.POPUP_CONSTANTS.GAME_INFO_MODAL })) : (react_1.default.createElement(ui_components_1.DesktopGameCard, { key: "".concat(game.id).concat(idx), gameId: game.id, withDemo: (_a = game === null || game === void 0 ? void 0 : game.settings) === null || _a === void 0 ? void 0 : _a['demo'], title: game.title, slug: game.slug, clickEvent: closeDigest, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_2.POPUP_CONSTANTS.SIGN_UP_MODAL }))));
            }),
            (games === null || games === void 0 ? void 0 : games.length) - 5 > 0 && react_1.default.createElement(ui_components_2.AllGames, { onClick: moreGamesClick })))));
};
exports.default = NewGames;
